/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AuthWaitVerifyEmailRouteImport } from './routes/auth/wait-verify-email'
import { Route as AuthVerifyPhoneRouteImport } from './routes/auth/verify-phone'
import { Route as AuthVerifyEmailRouteImport } from './routes/auth/verify-email'
import { Route as AuthRegisterRouteImport } from './routes/auth/register'
import { Route as AuthIdentifyRouteImport } from './routes/auth/identify'
import { Route as AuthCompleteProfileRouteImport } from './routes/auth/complete-profile'
import { Route as AppPerfilRouteImport } from './routes/app/perfil'
import { Route as AppCarteiraRouteImport } from './routes/app/carteira'
import { Route as AppEntregasIndexRouteImport } from './routes/app/entregas/index'
import { Route as SharedSolicitacaoIdAcompanharRouteImport } from './routes/shared/$solicitacaoId/acompanhar'
import { Route as AuthGoogleCallbackRouteImport } from './routes/auth/google/callback'
import { Route as AppPerfilIndicacoesRouteImport } from './routes/app/perfil_/indicacoes'
import { Route as AppPerfilEnderecosRouteImport } from './routes/app/perfil_/enderecos'
import { Route as AppEntregasSelectDestinationRouteImport } from './routes/app/entregas/select-destination'
import { Route as AppEntregasConfirmOriginRouteImport } from './routes/app/entregas/confirm-origin'
import { Route as AppEntregasCheckoutRouteImport } from './routes/app/entregas/checkout'
import { Route as AppEntregasEntregaIdIndexRouteImport } from './routes/app/entregas/$entregaId/index'
import { Route as AppEntregasEntregaIdAcompanharRouteImport } from './routes/app/entregas/$entregaId/acompanhar'

const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AuthWaitVerifyEmailRoute = AuthWaitVerifyEmailRouteImport.update({
  id: '/wait-verify-email',
  path: '/wait-verify-email',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthVerifyPhoneRoute = AuthVerifyPhoneRouteImport.update({
  id: '/verify-phone',
  path: '/verify-phone',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthIdentifyRoute = AuthIdentifyRouteImport.update({
  id: '/identify',
  path: '/identify',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthCompleteProfileRoute = AuthCompleteProfileRouteImport.update({
  id: '/complete-profile',
  path: '/complete-profile',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AppPerfilRoute = AppPerfilRouteImport.update({
  id: '/perfil',
  path: '/perfil',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppCarteiraRoute = AppCarteiraRouteImport.update({
  id: '/carteira',
  path: '/carteira',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppEntregasIndexRoute = AppEntregasIndexRouteImport.update({
  id: '/entregas/',
  path: '/entregas/',
  getParentRoute: () => AppRouteRoute,
} as any)
const SharedSolicitacaoIdAcompanharRoute =
  SharedSolicitacaoIdAcompanharRouteImport.update({
    id: '/shared/$solicitacaoId/acompanhar',
    path: '/shared/$solicitacaoId/acompanhar',
    getParentRoute: () => rootRouteImport,
  } as any)
const AuthGoogleCallbackRoute = AuthGoogleCallbackRouteImport.update({
  id: '/google/callback',
  path: '/google/callback',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AppPerfilIndicacoesRoute = AppPerfilIndicacoesRouteImport.update({
  id: '/perfil_/indicacoes',
  path: '/perfil/indicacoes',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPerfilEnderecosRoute = AppPerfilEnderecosRouteImport.update({
  id: '/perfil_/enderecos',
  path: '/perfil/enderecos',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppEntregasSelectDestinationRoute =
  AppEntregasSelectDestinationRouteImport.update({
    id: '/entregas/select-destination',
    path: '/entregas/select-destination',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppEntregasConfirmOriginRoute =
  AppEntregasConfirmOriginRouteImport.update({
    id: '/entregas/confirm-origin',
    path: '/entregas/confirm-origin',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppEntregasCheckoutRoute = AppEntregasCheckoutRouteImport.update({
  id: '/entregas/checkout',
  path: '/entregas/checkout',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppEntregasEntregaIdIndexRoute =
  AppEntregasEntregaIdIndexRouteImport.update({
    id: '/entregas/$entregaId/',
    path: '/entregas/$entregaId/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppEntregasEntregaIdAcompanharRoute =
  AppEntregasEntregaIdAcompanharRouteImport.update({
    id: '/entregas/$entregaId/acompanhar',
    path: '/entregas/$entregaId/acompanhar',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/app/carteira': typeof AppCarteiraRoute
  '/app/perfil': typeof AppPerfilRoute
  '/auth/complete-profile': typeof AuthCompleteProfileRoute
  '/auth/identify': typeof AuthIdentifyRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/auth/verify-phone': typeof AuthVerifyPhoneRoute
  '/auth/wait-verify-email': typeof AuthWaitVerifyEmailRoute
  '/app/': typeof AppIndexRoute
  '/app/entregas/checkout': typeof AppEntregasCheckoutRoute
  '/app/entregas/confirm-origin': typeof AppEntregasConfirmOriginRoute
  '/app/entregas/select-destination': typeof AppEntregasSelectDestinationRoute
  '/app/perfil/enderecos': typeof AppPerfilEnderecosRoute
  '/app/perfil/indicacoes': typeof AppPerfilIndicacoesRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/shared/$solicitacaoId/acompanhar': typeof SharedSolicitacaoIdAcompanharRoute
  '/app/entregas': typeof AppEntregasIndexRoute
  '/app/entregas/$entregaId/acompanhar': typeof AppEntregasEntregaIdAcompanharRoute
  '/app/entregas/$entregaId': typeof AppEntregasEntregaIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/app/carteira': typeof AppCarteiraRoute
  '/app/perfil': typeof AppPerfilRoute
  '/auth/complete-profile': typeof AuthCompleteProfileRoute
  '/auth/identify': typeof AuthIdentifyRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/auth/verify-phone': typeof AuthVerifyPhoneRoute
  '/auth/wait-verify-email': typeof AuthWaitVerifyEmailRoute
  '/app': typeof AppIndexRoute
  '/app/entregas/checkout': typeof AppEntregasCheckoutRoute
  '/app/entregas/confirm-origin': typeof AppEntregasConfirmOriginRoute
  '/app/entregas/select-destination': typeof AppEntregasSelectDestinationRoute
  '/app/perfil/enderecos': typeof AppPerfilEnderecosRoute
  '/app/perfil/indicacoes': typeof AppPerfilIndicacoesRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/shared/$solicitacaoId/acompanhar': typeof SharedSolicitacaoIdAcompanharRoute
  '/app/entregas': typeof AppEntregasIndexRoute
  '/app/entregas/$entregaId/acompanhar': typeof AppEntregasEntregaIdAcompanharRoute
  '/app/entregas/$entregaId': typeof AppEntregasEntregaIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/app': typeof AppRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/app/carteira': typeof AppCarteiraRoute
  '/app/perfil': typeof AppPerfilRoute
  '/auth/complete-profile': typeof AuthCompleteProfileRoute
  '/auth/identify': typeof AuthIdentifyRoute
  '/auth/register': typeof AuthRegisterRoute
  '/auth/verify-email': typeof AuthVerifyEmailRoute
  '/auth/verify-phone': typeof AuthVerifyPhoneRoute
  '/auth/wait-verify-email': typeof AuthWaitVerifyEmailRoute
  '/app/': typeof AppIndexRoute
  '/app/entregas/checkout': typeof AppEntregasCheckoutRoute
  '/app/entregas/confirm-origin': typeof AppEntregasConfirmOriginRoute
  '/app/entregas/select-destination': typeof AppEntregasSelectDestinationRoute
  '/app/perfil_/enderecos': typeof AppPerfilEnderecosRoute
  '/app/perfil_/indicacoes': typeof AppPerfilIndicacoesRoute
  '/auth/google/callback': typeof AuthGoogleCallbackRoute
  '/shared/$solicitacaoId/acompanhar': typeof SharedSolicitacaoIdAcompanharRoute
  '/app/entregas/': typeof AppEntregasIndexRoute
  '/app/entregas/$entregaId/acompanhar': typeof AppEntregasEntregaIdAcompanharRoute
  '/app/entregas/$entregaId/': typeof AppEntregasEntregaIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/app'
    | '/auth'
    | '/app/carteira'
    | '/app/perfil'
    | '/auth/complete-profile'
    | '/auth/identify'
    | '/auth/register'
    | '/auth/verify-email'
    | '/auth/verify-phone'
    | '/auth/wait-verify-email'
    | '/app/'
    | '/app/entregas/checkout'
    | '/app/entregas/confirm-origin'
    | '/app/entregas/select-destination'
    | '/app/perfil/enderecos'
    | '/app/perfil/indicacoes'
    | '/auth/google/callback'
    | '/shared/$solicitacaoId/acompanhar'
    | '/app/entregas'
    | '/app/entregas/$entregaId/acompanhar'
    | '/app/entregas/$entregaId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/app/carteira'
    | '/app/perfil'
    | '/auth/complete-profile'
    | '/auth/identify'
    | '/auth/register'
    | '/auth/verify-email'
    | '/auth/verify-phone'
    | '/auth/wait-verify-email'
    | '/app'
    | '/app/entregas/checkout'
    | '/app/entregas/confirm-origin'
    | '/app/entregas/select-destination'
    | '/app/perfil/enderecos'
    | '/app/perfil/indicacoes'
    | '/auth/google/callback'
    | '/shared/$solicitacaoId/acompanhar'
    | '/app/entregas'
    | '/app/entregas/$entregaId/acompanhar'
    | '/app/entregas/$entregaId'
  id:
    | '__root__'
    | '/'
    | '/app'
    | '/auth'
    | '/app/carteira'
    | '/app/perfil'
    | '/auth/complete-profile'
    | '/auth/identify'
    | '/auth/register'
    | '/auth/verify-email'
    | '/auth/verify-phone'
    | '/auth/wait-verify-email'
    | '/app/'
    | '/app/entregas/checkout'
    | '/app/entregas/confirm-origin'
    | '/app/entregas/select-destination'
    | '/app/perfil_/enderecos'
    | '/app/perfil_/indicacoes'
    | '/auth/google/callback'
    | '/shared/$solicitacaoId/acompanhar'
    | '/app/entregas/'
    | '/app/entregas/$entregaId/acompanhar'
    | '/app/entregas/$entregaId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRouteRoute: typeof AppRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  SharedSolicitacaoIdAcompanharRoute: typeof SharedSolicitacaoIdAcompanharRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/auth/wait-verify-email': {
      id: '/auth/wait-verify-email'
      path: '/wait-verify-email'
      fullPath: '/auth/wait-verify-email'
      preLoaderRoute: typeof AuthWaitVerifyEmailRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/verify-phone': {
      id: '/auth/verify-phone'
      path: '/verify-phone'
      fullPath: '/auth/verify-phone'
      preLoaderRoute: typeof AuthVerifyPhoneRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/verify-email': {
      id: '/auth/verify-email'
      path: '/verify-email'
      fullPath: '/auth/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/register': {
      id: '/auth/register'
      path: '/register'
      fullPath: '/auth/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/identify': {
      id: '/auth/identify'
      path: '/identify'
      fullPath: '/auth/identify'
      preLoaderRoute: typeof AuthIdentifyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/complete-profile': {
      id: '/auth/complete-profile'
      path: '/complete-profile'
      fullPath: '/auth/complete-profile'
      preLoaderRoute: typeof AuthCompleteProfileRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/app/perfil': {
      id: '/app/perfil'
      path: '/perfil'
      fullPath: '/app/perfil'
      preLoaderRoute: typeof AppPerfilRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/carteira': {
      id: '/app/carteira'
      path: '/carteira'
      fullPath: '/app/carteira'
      preLoaderRoute: typeof AppCarteiraRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/entregas/': {
      id: '/app/entregas/'
      path: '/entregas'
      fullPath: '/app/entregas'
      preLoaderRoute: typeof AppEntregasIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/shared/$solicitacaoId/acompanhar': {
      id: '/shared/$solicitacaoId/acompanhar'
      path: '/shared/$solicitacaoId/acompanhar'
      fullPath: '/shared/$solicitacaoId/acompanhar'
      preLoaderRoute: typeof SharedSolicitacaoIdAcompanharRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/google/callback': {
      id: '/auth/google/callback'
      path: '/google/callback'
      fullPath: '/auth/google/callback'
      preLoaderRoute: typeof AuthGoogleCallbackRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/app/perfil_/indicacoes': {
      id: '/app/perfil_/indicacoes'
      path: '/perfil/indicacoes'
      fullPath: '/app/perfil/indicacoes'
      preLoaderRoute: typeof AppPerfilIndicacoesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/perfil_/enderecos': {
      id: '/app/perfil_/enderecos'
      path: '/perfil/enderecos'
      fullPath: '/app/perfil/enderecos'
      preLoaderRoute: typeof AppPerfilEnderecosRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/entregas/select-destination': {
      id: '/app/entregas/select-destination'
      path: '/entregas/select-destination'
      fullPath: '/app/entregas/select-destination'
      preLoaderRoute: typeof AppEntregasSelectDestinationRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/entregas/confirm-origin': {
      id: '/app/entregas/confirm-origin'
      path: '/entregas/confirm-origin'
      fullPath: '/app/entregas/confirm-origin'
      preLoaderRoute: typeof AppEntregasConfirmOriginRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/entregas/checkout': {
      id: '/app/entregas/checkout'
      path: '/entregas/checkout'
      fullPath: '/app/entregas/checkout'
      preLoaderRoute: typeof AppEntregasCheckoutRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/entregas/$entregaId/': {
      id: '/app/entregas/$entregaId/'
      path: '/entregas/$entregaId'
      fullPath: '/app/entregas/$entregaId'
      preLoaderRoute: typeof AppEntregasEntregaIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/entregas/$entregaId/acompanhar': {
      id: '/app/entregas/$entregaId/acompanhar'
      path: '/entregas/$entregaId/acompanhar'
      fullPath: '/app/entregas/$entregaId/acompanhar'
      preLoaderRoute: typeof AppEntregasEntregaIdAcompanharRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AppRouteRouteChildren {
  AppCarteiraRoute: typeof AppCarteiraRoute
  AppPerfilRoute: typeof AppPerfilRoute
  AppIndexRoute: typeof AppIndexRoute
  AppEntregasCheckoutRoute: typeof AppEntregasCheckoutRoute
  AppEntregasConfirmOriginRoute: typeof AppEntregasConfirmOriginRoute
  AppEntregasSelectDestinationRoute: typeof AppEntregasSelectDestinationRoute
  AppPerfilEnderecosRoute: typeof AppPerfilEnderecosRoute
  AppPerfilIndicacoesRoute: typeof AppPerfilIndicacoesRoute
  AppEntregasIndexRoute: typeof AppEntregasIndexRoute
  AppEntregasEntregaIdAcompanharRoute: typeof AppEntregasEntregaIdAcompanharRoute
  AppEntregasEntregaIdIndexRoute: typeof AppEntregasEntregaIdIndexRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppCarteiraRoute: AppCarteiraRoute,
  AppPerfilRoute: AppPerfilRoute,
  AppIndexRoute: AppIndexRoute,
  AppEntregasCheckoutRoute: AppEntregasCheckoutRoute,
  AppEntregasConfirmOriginRoute: AppEntregasConfirmOriginRoute,
  AppEntregasSelectDestinationRoute: AppEntregasSelectDestinationRoute,
  AppPerfilEnderecosRoute: AppPerfilEnderecosRoute,
  AppPerfilIndicacoesRoute: AppPerfilIndicacoesRoute,
  AppEntregasIndexRoute: AppEntregasIndexRoute,
  AppEntregasEntregaIdAcompanharRoute: AppEntregasEntregaIdAcompanharRoute,
  AppEntregasEntregaIdIndexRoute: AppEntregasEntregaIdIndexRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthCompleteProfileRoute: typeof AuthCompleteProfileRoute
  AuthIdentifyRoute: typeof AuthIdentifyRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
  AuthVerifyPhoneRoute: typeof AuthVerifyPhoneRoute
  AuthWaitVerifyEmailRoute: typeof AuthWaitVerifyEmailRoute
  AuthGoogleCallbackRoute: typeof AuthGoogleCallbackRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthCompleteProfileRoute: AuthCompleteProfileRoute,
  AuthIdentifyRoute: AuthIdentifyRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
  AuthVerifyPhoneRoute: AuthVerifyPhoneRoute,
  AuthWaitVerifyEmailRoute: AuthWaitVerifyEmailRoute,
  AuthGoogleCallbackRoute: AuthGoogleCallbackRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRouteRoute: AppRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  SharedSolicitacaoIdAcompanharRoute: SharedSolicitacaoIdAcompanharRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
